<template>
  <button @click="$emit(action)" type="button" class="w3-button w3-text-theme" style="margin:0px; padding:0px">
    <font-awesome-icon :icon="[type, icon]" />
  </button> 
</template>

<script>
  import EditButton from "./EditButton.ts";

  export default EditButton;
</script>
